import { canNavigate } from '@/plugins/acl/routeProtection'
import store from '@/store'
import Vue from 'vue'
import VueRouter from 'vue-router'
import access from './pages/access'
import api from './pages/api'
import categories from './pages/categories'
import appCategories from './pages/app-categories'
import comments from './pages/comments'
import financial from './pages/financial'
import logs from './pages/logs'
import managePageWeb from './pages/manage-page-web'
import marketing from './pages/marketing'
import products from './pages/products'
import setting from './pages/setting'
import tickets from './pages/tickets'
import users from './pages/users'
import reports from './pages/reports'
import accounting from './pages/accounting'
import analyze from './pages/analyze'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: 'home',
  },
  {
    path: '/version-history',
    name: 'last_version',
    component: () => import('@/views/versionHistory/IndexPage.vue'),
    meta: {
      resource: 'all',
      layout: 'content',
      requiresAuth: false,
    },
  },
  {
    path: '/home',
    name: 'home',
    component: () => import('@/views/Home.vue'),
    meta: {
      requiresAuth: true,
      action: 'can_see_dashboard',
      resource: 'all',
      layout: 'content',
    },
  },
  {
    path: '/login',
    name: 'auth-login',
    component: () => import('@/views/auth/Login.vue'),
    meta: {
      resource: 'Public',
      layout: 'blank',
      requiresAuth: false,
      redirectIfLoggedIn: true,
    },
  },
  {
    path: '/forgot-password',
    name: 'forgot-password',
    component: () => import('@/views/auth/ForgotPassword.vue'),
    meta: {
      resource: 'Public',
      layout: 'blank',
      requiresAuth: false,
    },
  },
  {
    path: '/not-authorized',
    name: 'not-authorized',
    component: () => import('@/views/auth/NotAuthorized.vue'),
    meta: {
      resource: 'Public',
      layout: 'blank',
      requiresAuth: false,
    },
  },
  {
    path: '*',
    redirect: 'error-404',
  },
  ...products,
  ...tickets,
  ...access,
  ...categories,
  ...users,
  ...setting,
  ...api,
  ...financial,
  ...logs,
  ...marketing,
  ...comments,
  ...managePageWeb,
  ...appCategories,
  ...reports,
  ...accounting,
  ...analyze,
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
})

const auth = {
  loggedIn() {
    return store.state.token !== '' || localStorage.getItem('token') !== null
  },
}
router.beforeEach((to, _, next) => {
  if (to.meta.requiresAuth) {
    if (!canNavigate(to)) {
      // Redirect to login if not logged in
      if (!auth.loggedIn()) {
        return next({ name: 'auth-login', query: { marketplace: to.query.marketplace } })
      }

      // If logged in => not authorized
      return next({ name: 'not-authorized' })
    }
  }

  // Redirect if logged in
  if (to.meta.redirectIfLoggedIn && auth.loggedIn()) {
    next('/')
  }

  return next()
})

export default router
